import { useGlobals } from "@/components/providers/globals-provider.tsx";
import EventButton from "@/components/ui/event-button.tsx";
import ContactForm from "@/features/sub-families/components/summary/contact-form.tsx";
import useShortCode from "@/features/sub-families/hooks/use-short-code.ts";
import { useTranslations } from "@/features/translations/components/translations";
import { useAppSelector } from "@/redux/store.ts";
import { type Nullable, WebComponentMode } from "@/types";

type Props = { smartNumber: Nullable<string> };
export default function ConfiguratorModeActionButton({ smartNumber }: Props) {
    const t = useTranslations();
    const { mode } = useGlobals();

    const crmPath = useAppSelector((state) => state.crm.crmPath);
    const { shortCode, isLoading } = useShortCode(smartNumber);

    switch (mode) {
        case WebComponentMode.Website:
            return crmPath ? <ContactForm crmPath={crmPath} /> : null;

        case WebComponentMode.ShoppingCart:
        case WebComponentMode.ProjectRequest:
            if (!smartNumber) return null;

            return (
                <EventButton
                    event="summary-action-click"
                    data={{ smartNumber, shortCode, mode }}
                    disabled={isLoading}
                    background="dark"
                    className="button--configurator-mode-action"
                >
                    {t(mode === WebComponentMode.ShoppingCart ? "buy_now" : "add_to_project")}
                </EventButton>
            );

        default:
            return null;
    }
}
